<ng-container *ngIf="isBindingUnbindingInProgress$ | async; else elseTemplate">
    <lta-svg-icon size="20" icon="loading"></lta-svg-icon>
</ng-container>

<ng-template #elseTemplate>
    <span *ngIf="!item.origin_object">{{ 'lta.bind' | translate }}</span>
    <span *ngIf="item.origin_object">{{ 'lta.unbind' | translate }}</span>
</ng-template>

